import React from 'react'
import { Route, Routes } from 'react-router-dom'

import MainLayout from '../../layouts/Main'
import AdminLayout from '../../layouts/Admin'
import DebitLayout from '../../layouts/Debit'
import QueryLayout from '../../layouts/Query'
import Spinner from '../../components/Spinner'

import PrivateRoute from './private'

const Login = React.lazy(() => import('../../pages/Login'))
const LoginMiCuenta = React.lazy(() => import('../../pages/LoginMiCuenta'))
const RecuperarContrasena = React.lazy(() => import('../../pages/RecuperarContrasena'))
const Register = React.lazy(() => import('../../pages/Register'))
const Home = React.lazy(() => import('../../pages/Home'))
const Notice = React.lazy(() => import('../../pages/Notice'))
const Payment = React.lazy(() => import('../../pages/Payment'))
const Historic = React.lazy(() => import('../../pages/Historic'))
const Document = React.lazy(() => import('../../pages/Document'))
const Verification = React.lazy(() => import('../../pages/Verification'))
const Checkout = React.lazy(() => import('../../pages/Checkout'))
const DInternal = React.lazy(() => import('../../pages/Debit/Internal'))
const DExternal = React.lazy(() => import('../../pages/Debit/External'))
const DConfirmation = React.lazy(() => import('../../pages/Debit/Confirmation'))
const DPayment = React.lazy(() => import('../../pages/Debit/Payment'))
const DSuccess = React.lazy(() => import('../../pages/Debit/Success'))
const Prepayment = React.lazy(() => import('../../pages/Prepayment'))
const AList = React.lazy(() => import('../../pages/Another/List'))
const ADetail = React.lazy(() => import('../../pages/Another/Detail'))
const RList = React.lazy(() => import('../../pages/Request/List'))
const RNew = React.lazy(() => import('../../pages/Request/New'))
const RDetail = React.lazy(() => import('../../pages/Request/Detail'))
const Record = React.lazy(() => import('../../pages/Record'))
const Note = React.lazy(() => import('../../pages/Note'))
const Advance = React.lazy(() => import('../../pages/Advance'))
const CancelarCuenta = React.lazy(() => import('../../pages/Info/CancelarCuenta'))
const NotFoundPage = React.lazy(() => import('../../pages/NotFoundPage'))
const VerificationEmail = React.lazy(() => import('../../pages/VerificationEmail'))
const VerificationEmailPIN = React.lazy(() => import('../../pages/VerificationEmailPIN'))
const Externo = React.lazy(() => import('../../pages/Externo'))

export const Router = () => {
    return (
        <React.Suspense fallback={<Spinner isShow={true} />}>
            <Routes>
                <Route element={<MainLayout />}>
                    <Route path='/' element={<Home />} />
                    <Route path='/:externo' element={<Externo />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/Baja' element={<CancelarCuenta />} />
                    <Route path='/MiCuenta/IngresoPin' element={<Login />} />
                    <Route path='/micuenta/ingresopin' element={<Login />} />
                    <Route path='/MiCuenta/IngresoSeparacionCI' element={<Login />} />
                    <Route path='/micuenta/ingresoseparacionci' element={<Login />} />
                    <Route path='/MiCuenta/Ingreso' element={<LoginMiCuenta />} />
                    <Route path='/micuenta/ingreso' element={<LoginMiCuenta />} />
                    <Route path='/MiCuenta/recuperar-mi-contrasena/:id' element={<RecuperarContrasena />} />
                    <Route path='/micuenta/recuperar-mi-contrasena/:id' element={<RecuperarContrasena />} />
                    <Route path='/MiCuenta/Registro' element={<Register />} />
                    <Route path='/micuenta/registro' element={<Register />} />
                    <Route path='/verification' element={<Verification />} />
                    <Route path='/verificationEmail' element={<VerificationEmail />} />
                    <Route path='/verificationEmail/PIN' element={<VerificationEmailPIN />} />
                    <Route element={<PrivateRoute />}>
                        <Route path='/debit-automatic' element={<DExternal />} />
                        <Route element={<QueryLayout />}>
                            <Route path='query'>
                                <Route path='prepayment' element={<Prepayment />} />
                                <Route path='record' element={<Record />} />
                                <Route path='note' element={<Note />} />
                                <Route path='request'>
                                    <Route path='' element={<RList />} />
                                    <Route path=':id' element={<RDetail />} />
                                    <Route path='new' element={<RNew />} />
                                </Route>
                                <Route path='historic'>
                                    <Route path='' element={<AList />} />
                                    <Route path=':id' element={<ADetail />} />
                                </Route>
                            </Route>
                        </Route>
                        <Route element={<AdminLayout />}>
                            <Route path='property'>
                                <Route path=':id/payment' element={<Payment />} />
                                <Route path=':id/debit' element={<DInternal />} />
                                <Route path=':id/historic' element={<Historic />} />
                                <Route path=':id/advance' element={<Advance />} />
                                <Route path=':id/documents' element={<Document />} />
                                <Route path=':id/notices' element={<Notice />} />
                            </Route>
                        </Route>
                        <Route path='checkout'>
                            <Route path=':id' element={<Checkout />} />
                        </Route>
                        <Route element={<DebitLayout />}>
                            <Route path='debit'>
                                <Route path=':id/confirmation' element={<DConfirmation />} />
                                <Route path=':id/payment' element={<DPayment />} />
                            </Route>
                        </Route>
                        <Route path='success'>
                            <Route path='debit' element={<DSuccess />} />
                        </Route>
                    </Route>

                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </React.Suspense>
    )
}
